// src/components/product-library/SearchBar.js
import React from "react";
import "./SearchBar.css";

const SearchBar = ({ value, onChange, isLoading, placeholder }) => {
  return (
    <div className="pl-searchbar">
      <span className="pl-search-icon">
        <i className="flaticon2-search-1"></i>
      </span>

      <input
        type="text"
        className="pl-search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Search by name, SKU, category..."}
      />

      <button className="pl-search-go-btn" disabled={isLoading}>
        {isLoading ? (
          <div className="pl-search-spinner"></div>
        ) : (
          "GO"
        )}
      </button>
    </div>
  );
};

export default SearchBar;
